export enum NetworkState {
    ONLINE = 'online',
    OFFLINE = 'offline',
    RECONNECTING = 'reconnecting',
}

export enum NetworkQualityType {
    BAD = 'bad',
    GOOD = 'good',
}

export enum ConferenceStatus {
    JOINING = 'joining',
    WAITING_ROOM = 'waiting_room',
    READY_TO_JOIN = 'ready_to_join',
    JOINED = 'joined',
    FAILED = 'failed',
    DISCONNECTED = 'disconnected',
}

export enum GRID_VIEW {
    DEFAULT = 'default',
    PRESENTER = 'presenter',
}

export enum GRID_ITEM_RATIO {
    DEFAULT = 16 / 9,
    SQUARE = 1,
}

export const VIDEO_CONSTRAINTS = {
    width: { ideal: 641 }, // 641 во избежание кропа и зума https://st.yandex-team.ru/CHEMODAN-75944
    height: { ideal: 360 },
    frameRate: { ideal: 24 },
    naturalWidth: 640,
    naturalHeight: 360,
};

export const PREVIEW_VIDEO_CONSTRAINTS = {
    width: { ideal: 1280 },
    height: { ideal: 720 },
    frameRate: { ideal: 30 },
};

export enum DESKTOP_SHARING_STATUS {
    LOCAL = 'local',
    REMOTE = 'remote',
    NONE = 'none',
}

export const VIRTUAL_CALLEE = 'VIRTUAL_CALLEE';

export enum PeersTabValue {
    Conference = 'Conference',
    WaitingRoom = 'WaitingRoom',
}

export const REACTION_ICON_SIZES = {
    XL: { size: 56, indent: 24 },
    L: { size: 48, indent: 16 },
    M: { size: 32, indent: 8 },
    S: { size: 24, indent: 6 },
    XS: { size: 16, indent: 6 },
} as const;

export const N_LAST_OPTION = { nCount: 1, showInSubGrid: false };

export const RECORD_MIME_TYPE = 'video/webm;codecs=vp8,opus';

export const MAX_DISPLAY_PARTICIPANTS_IN_GRID = 12;

export enum MediaStatus {
    UNMUTED = 'unmuted',
    MUTED = 'muted',
    BLOCKED = 'blocked',
}

export enum ShareDesktopStatus {
    SHARING = 'sharing',
    UNSHARING = 'unsharing',
    BLOCKED = 'blocked',
}
